<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import { translations, current_lang } from '../stores.js';

    let selected = null;

    function show_android(){
        selected = "android";
    }
    function show_ios(){
        selected = "ios";
    }
</script>
<SubPageHeader page_title={$translations["INSTRUCTIONS"][$current_lang]} is_section_main_page={true}/>
<div class="content-container">
    <h4>{$translations["CHOOSE_YOUR_OS"][$current_lang]}</h4>
    <div class="buttons">
        <div class="simplebutton" on:click={show_android}>Android</div>
        <div class="simplebutton" on:click={show_ios}>iOS</div>
    </div>

    {#if $current_lang == "FI"}
        {#if selected =="android"}
            <h2>Android (Chrome)</h2>
            <h3>Sovelluksen asentaminen kotinäytölle</h3>

            <h4>Asennustapa 1:</h4>
            <p>Useimmilla Android-laitteilla ruudulle ilmestyy selaimen oma ilmoitus sovelluksen asentamisesta tai lisäämisestä kotinäytölle. Helpoin tapa on asentaa sovellus suoraan tätä kautta. Seuraa asennuksen vaiheita ja hetken kuluttua sovelluksen pitäisi ilmestyä kotinäytöllesi.</p>
        
            <h4>Asennustapa 2:</h4>
            <p>Sovellus voidaan asentaa selaimen valikon kautta.
            <p>1. Avaa selaimen valikko ja näpäytä <strong>Asenna sovellus</strong> (valikkoteksti riippuu käytettävästä kielestä).</p>
            <p>2. Seuraa loppuja asennuksen vaiheita ja hetken kuluttua sovellus on lisätty kotinäytöllesi.</p>


            <h3>Poistaminen</h3>
            <p>Sovellus poistetaan laitteelta sovellusvalikon kautta.</p>
        {/if}
        {#if selected == "ios"}
            <h2>iOS (Safari)</h2>
            <h3>Sovelluksen asentaminen kotinäytölle</h3>
            <p>1. Näpäyta valikkorivillä <img id="share-icon" src="img/instructions_imgs/share_icon2.png" alt="Share" />-painiketta</p>
            <p>2. Vieritä vaihtoehtojen luetteloa alaspäin ja näpäytä <strong>Lisää Koti-valikkoon / Add to Home Screen</strong>. 
            <p>3. Seuraavaksi näet valinnan, josta voi vaihtaa sovelluksen nimeä. Näpäytä <strong>Lisää / Add</strong>.</p>
            <p>4. Sovellus on nyt käytettävissä suoraan koti-valikon kautta</p>

            <h3>Poistaminen</h3>
            <p>Sovellus poistetaan kotinäytöltä pitämällä sormea sovelluksen kuvakkeen päällä ja valitsemalla <strong>Poista kirjanmerkki</strong>.</p>
        {/if}
    {/if}
    {#if $current_lang == "EN"}
        {#if selected =="android"}
            <h2>Android (Chrome)</h2>
            <h3>Installing the app to your home screen</h3>

            <h4>Method 1:</h4>
            <p>If you see a browser notification to add this app to your home screen, you can follow the steps and install the app this way.</p>
        
            <h4>Method 2:</h4>
            <p>You can install the app from the settings-menu of your browser.</p>
            <p>1. Open settings menu</p>
            <p>2. Tap <strong>Install app</strong></p>
            <p>3. Follow the installation steps and the app will be added to your home screen.</p>

            <h3>Uninstalling the app</h3>
            <p>You can uninstall the app from the app menu</p>
        {/if}
        {#if selected == "ios"}
            <h2>iOS (Safari)</h2>
            <h3>Installing the app to your home screen</h3>
            <p>1. Tap the <img id="share-icon" src="img/instructions_imgs/share_icon2.png" alt="Share" /> button in the menu bar.</p>
            <p>2. Scroll down the list of options, then tap <strong>Add to home screen.</strong></p>
            <p>3. Accept the name for the shortcut, then tap <strong>Add</strong>.</p>

            <h3>Uninstalling the app</h3>
            <p>Hold your finger on the app icon and select <strong>Delete Bookmark</strong>.</p>
        {/if}
    {/if}
</div>
<style>
    h2{
        margin-bottom: 30px;
    }
    h3{
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 1.6rem;
    }
    h4{
        margin-top: 0;
        margin-bottom: 15px;
        font-size: 1.2rem;
    }

    #share-icon{
        width: 15px;
        height: auto;
    }
    .buttons{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .buttons .simplebutton:not(:first-of-type){
        margin-left: 15px;
    }
</style>